import $ from 'jquery';

$(document).ready(function() {
	$('.js-slide-full').slick({
		dots: true,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
	  });
});




// WEBPACK FOOTER //
// ./src/js/pages/index/slide-full.js